import { render, staticRenderFns } from "./EncyclopediaArticlesInner.vue?vue&type=template&id=363e0441&"
import script from "./EncyclopediaArticlesInner.vue?vue&type=script&lang=js&"
export * from "./EncyclopediaArticlesInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports